const carouselItems = [
  {
    id: 'carousel-1',
    title: '最新上架',
    desc: '每周五准时更新最新院线大片与海外新片，第一时间带来热门电影资源，让你不落人后。',
    tag: '院线同步',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20clapperboard%20and%20movie%20reel%20on%20warm%20dark%20background%20with%20soft%20golden%20ambient%20lighting%20elegant%20cinema%20atmosphere%20sophisticated%20movie%20production%20aesthetic%20with%20subtle%20lens%20flare&width=800&height=450&seq=carousel-2026-01&orientation=landscape',
    alt: '最新上架电影专题',
  },
  {
    id: 'carousel-2',
    title: '剧集热播',
    desc: '热门电视剧全集连播不间断，口碑国剧、高分美剧、经典韩剧持续更新中，追剧必备。',
    tag: '每日连播',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20television%20screen%20displaying%20movie%20night%20ambient%20glow%20soft%20golden%20lighting%20cinematic%20evening%20atmosphere%20with%20comfortable%20decor&width=800&height=450&seq=carousel-2026-02&orientation=landscape',
    alt: '剧集热播专题',
  },
  {
    id: 'carousel-3',
    title: '综艺精选',
    desc: '热门综艺节目实时更新，搞笑综艺、音乐竞演、真人秀等类型齐全，欢乐源源不断。',
    tag: '实时更新',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20scene%20with%20warm%20stage%20spotlights%20and%20microphone%20on%20dark%20theater%20background%20entertainment%20atmosphere%20with%20rich%20golden%20amber%20lighting%20and%20soft%20glow&width=800&height=450&seq=carousel-2026-03&orientation=landscape',
    alt: '综艺精选专题',
  },
  {
    id: 'carousel-4',
    title: '蓝光专享',
    desc: '蓝光画质专区提供超高清晰度观影体验，支持多码率自适应，弱网环境下也能流畅播放。',
    tag: '超清体验',
    image: 'https://readdy.ai/api/search-image?query=Crystal%20clear%20cinematic%20lens%20with%20beautiful%20flare%20effects%20on%20elegant%20dark%20sophisticated%20background%20high%20definition%20visual%20quality%20concept%20with%20warm%20golden%20light%20reflections%20and%20bokeh%20particles&width=800&height=450&seq=carousel-2026-04&orientation=landscape',
    alt: '蓝光专享专题',
  },
  {
    id: 'carousel-5',
    title: '动漫天地',
    desc: '日漫国漫经典与新番一网打尽，热血、治愈、搞笑、悬疑全类型覆盖，二次元爱好者的乐园。',
    tag: '全类型覆盖',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20elements%20with%20warm%20cinematic%20dark%20background%20soft%20golden%20and%20amber%20toned%20aesthetic%20beautiful%20composition%20with%20Japanese%20animation%20inspired%20visual%20elements&width=800&height=450&seq=carousel-2026-05&orientation=landscape',
    alt: '动漫天地专题',
  },
];

const cardItems = [
  {
    id: 'card-1',
    title: '最新电影',
    desc: '国内外院线新片第一时间更新，高清画质在线观看，支持多线路切换，观影无忧。',
    icon: 'ri-movie-line',
    image: 'https://readdy.ai/api/search-image?query=Film%20reel%20and%20popcorn%20on%20dark%20warm%20cinematic%20background%20with%20soft%20golden%20ambient%20light%20elegant%20movie%20night%20aesthetic%20cozy%20theater%20atmosphere&width=600&height=400&seq=cards-2026-01&orientation=landscape',
    alt: '最新电影',
  },
  {
    id: 'card-2',
    title: '热播剧集',
    desc: '口碑国产剧、高分英美剧、经典韩剧日剧，热门剧集追不停，全集连播更新快。',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20remote%20control%20and%20screen%20glow%20on%20warm%20dark%20background%20cozy%20evening%20television%20watching%20scene%20with%20soft%20amber%20lighting%20cinematic%20home%20entertainment&width=600&height=400&seq=cards-2026-02&orientation=landscape',
    alt: '热播剧集',
  },
  {
    id: 'card-3',
    title: '综艺娱乐',
    desc: '搞笑综艺、音乐竞演、慢生活真人秀等热门综艺全覆盖，欢笑不断轻松解压。',
    icon: 'ri-emotion-laugh-line',
    image: 'https://readdy.ai/api/search-image?query=Stage%20microphone%20with%20warm%20spotlights%20on%20dark%20entertainment%20background%20comedy%20variety%20show%20atmosphere%20with%20rich%20golden%20lighting%20and%20theater%20ambiance&width=600&height=400&seq=cards-2026-03&orientation=landscape',
    alt: '综艺娱乐',
  },
  {
    id: 'card-4',
    title: '纪录片专区',
    desc: '自然、历史、科技、人文等优质纪录片汇聚，足不出户探索大千世界的奥秘。',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20globe%20with%20warm%20ambient%20lighting%20on%20dark%20sophisticated%20background%20exploration%20and%20discovery%20theme%20with%20golden%20tones%20cinematic%20documentary%20aesthetic&width=600&height=400&seq=cards-2026-04&orientation=landscape',
    alt: '纪录片专区',
  },
  {
    id: 'card-5',
    title: '动漫番剧',
    desc: '热血战斗、治愈日常、烧脑推理等海量动漫作品，日漫国漫同步更新不落下。',
    icon: 'ri-paint-brush-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20artistic%20anime%20illustration%20style%20elements%20on%20warm%20dark%20background%20with%20soft%20golden%20accents%20creative%20composition%20inspired%20by%20Japanese%20animation%20cinematic%20aesthetic&width=600&height=400&seq=cards-2026-05&orientation=landscape',
    alt: '动漫番剧',
  },
  {
    id: 'card-6',
    title: '海外大片',
    desc: '好莱坞精选、欧洲文艺片、日韩佳作，原声字幕双语可选，沉浸式环球观影体验。',
    icon: 'ri-earth-line',
    image: 'https://readdy.ai/api/search-image?query=Hollywood%20style%20cinematic%20composition%20with%20warm%20golden%20lighting%20on%20dark%20background%20elegant%20film%20noir%20aesthetic%20sophisticated%20international%20cinema%20atmosphere%20with%20soft%20glow&width=600&height=400&seq=cards-2026-06&orientation=landscape',
    alt: '海外大片',
  },
];

export default function SectionsA() {
  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* #carousel - 5 static items all visible */}
      <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
              焦点专题
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精选优质影视内容专题，涵盖电影、剧集、综艺、动漫等多元类型
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-primary-50 text-primary-700 text-[10px] font-medium mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* #contact - 1 contact entry */}
      <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
              联系咨询
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              联系咨询
            </h2>
            <p className="text-sm text-foreground-500 mb-8">
              如有内容建议、合作意向或问题反馈，欢迎通过以下方式联系我们
            </p>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
              <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-6 mb-6">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
                </div>
                <div className="text-left">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">投稿与合作咨询</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    无论是内容推荐、版权合作还是广告投放，我们的运营团队将在24小时内回复您的来信。
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="mailto:contact@chunye.tv"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line text-base"></i>
                  发送邮件咨询
                </a>
                <span className="text-sm text-foreground-400 whitespace-nowrap">
                  或发送至 contact@chunye.tv
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #cards - 6 info cards */}
      <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
              精选内容
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选内容
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              覆盖电影、剧集、综艺、纪录片、动漫、海外六大核心频道
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {cardItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2.5 mb-2">
                    <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-primary-600 text-sm`}></i>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}